import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const posts = [
  {
    category: 'Philosophy',
    tag: 'दर्शन',
    date: 'April 2025',
    title: 'Why Ancient Wisdom is the Most Advanced Framework for Modern Tech Teams',
    excerpt: 'The Bhagavad Gita speaks of nishkama karma — action without attachment to results. For engineering teams, this is revolutionary: build with full commitment, release without ego.',
    readTime: '6 min',
    gradient: 'linear-gradient(135deg, rgba(232,115,42,0.12), rgba(201,168,76,0.06))',
  },
  {
    category: 'AI & Ethics',
    tag: 'नैतिकता',
    date: 'March 2025',
    title: 'The Sattvic AI: Building Artificial Intelligence that Serves, Not Dominates',
    excerpt: 'Vedic thought classifies all existence into three gunas. Sattva represents purity and clarity — the exact quality we must infuse into our AI systems to ensure they elevate rather than diminish.',
    readTime: '8 min',
    gradient: 'linear-gradient(135deg, rgba(201,168,76,0.1), rgba(232,115,42,0.06))',
  },
  {
    category: 'Wellness',
    tag: 'कल्याण',
    date: 'February 2025',
    title: 'Deep Work in a Distracted World: The IT Professional\'s Guide to Inner Stillness',
    excerpt: 'The forest hermitages of ancient India were not escape from responsibility — they were optimization for clarity. Modern tech workers can access this same stillness without leaving their desk.',
    readTime: '5 min',
    gradient: 'linear-gradient(135deg, rgba(232,115,42,0.08), rgba(201,168,76,0.1))',
  },
];

export default function Insights() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="insights" ref={ref} style={{
      padding: '120px 5%',
      background: '#0D0D0D',
      position: 'relative',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 60, flexWrap: 'wrap', gap: 20 }}
        >
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
              <div style={{ width: 40, height: 1, background: 'linear-gradient(to right, transparent, #C9A84C)' }} />
              <span style={{ fontFamily: 'Cinzel', fontSize: 11, letterSpacing: 4, color: '#C9A84C', textTransform: 'uppercase' }}>Wisdom Archive</span>
            </div>
            <h2 style={{
              fontFamily: 'Cinzel',
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              color: '#F5F0E8',
              letterSpacing: 2,
            }}>
              Insights
            </h2>
          </div>
          <motion.button
            whileHover={{ scale: 1.04 }}
            style={{
              background: 'transparent',
              border: '1px solid rgba(201,168,76,0.3)',
              borderRadius: 4,
              padding: '10px 24px',
              color: '#C9A84C',
              fontFamily: 'Inter',
              fontSize: 12,
              letterSpacing: 2,
              textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            View All Insights →
          </motion.button>
        </motion.div>

        {/* Post grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: 28,
        }}>
          {posts.map((post, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              whileHover={{ y: -6 }}
              style={{
                background: post.gradient,
                border: '1px solid rgba(201,168,76,0.12)',
                borderRadius: 12,
                padding: '32px',
                cursor: 'pointer',
                transition: 'border-color 0.3s',
              }}
            >
              {/* Meta */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <span style={{
                  background: 'rgba(232,115,42,0.15)',
                  border: '1px solid rgba(232,115,42,0.3)',
                  borderRadius: 20,
                  padding: '3px 12px',
                  fontSize: 11,
                  color: '#E8732A',
                  letterSpacing: 1,
                }}>
                  {post.category}
                </span>
                <span style={{ fontFamily: 'Cinzel', fontSize: 14, color: 'rgba(201,168,76,0.3)' }}>
                  {post.tag}
                </span>
              </div>

              <h3 style={{
                fontFamily: 'Playfair Display',
                fontSize: 18,
                color: '#F5F0E8',
                lineHeight: 1.5,
                marginBottom: 16,
              }}>
                {post.title}
              </h3>

              <p style={{ color: '#B0A898', lineHeight: 1.8, fontSize: 13, marginBottom: 24 }}>
                {post.excerpt}
              </p>

              {/* Footer */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 11, color: '#6B6560', letterSpacing: 1 }}>{post.date}</span>
                <span style={{ fontSize: 11, color: '#6B6560', letterSpacing: 1 }}>{post.readTime} read</span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
